import { z } from "zod"

import { WarehouseShelvingBinSize } from "@/graphql/codegen/graphql"
import type { WarehouseShelvingBinSize as WarehouseShelvingBinSizeType } from "@/graphql/codegen/graphql"

export interface DestinationOverride {
  warehouseShelvingId: string
  aisleCode: string
  sectionCode: string
  binNumber: number
  binSize?: WarehouseShelvingBinSizeType
}

export const overrideDestinationFormSchema = z.object({
  binSize: z.nativeEnum(WarehouseShelvingBinSize).nullable(),
  aisleCode: z.string().min(1, "Aisle is required"),
  sectionCode: z.string().min(1, "Shelf is required"),
  binNumber: z.number().min(1, "Bin is required"),
})

export type OverrideDestinationFormValues = z.infer<typeof overrideDestinationFormSchema>
